<template>
  <section class="" :class="{ mobile: rootStore.isMobile }">
    <section class="product-detail">
      <!--  <detail-view @close="closeProduct"> -->

      <section class="left-part">
        <close-button
          v-if="rootStore.isMobile"
          class="close-button"
          @click="$emit('close')"
        ></close-button>

        <section class="product-image-container">
          <div class="image-container">
            <div v-if="productImage === ''">
              <span class="message">Afbeelding genereren</span>
              <bouncing-spinner></bouncing-spinner>
            </div>
            <img :class="{ border: displaySpecs.border }" :src="productImage" />
          </div>
          <div class="img-button-holder">
            <print-store-file-upload
              @uploadComplete="onUploadComplete($event)"
              caption="PREVIEW WIJZIGEN"
              :is-preview="true"
            >
            </print-store-file-upload>
            <button class="main-button" @click="regeneratePreview()">
              origineel herstellen
            </button>
          </div>
          <h1 class="product-title" :title="productEdit.name">
            {{ productEdit.name }}
          </h1>
        </section>
      </section>

      <section class="right-part">
        <close-button
          v-if="!rootStore.isMobile"
          class="close-button"
          @click="$emit('close')"
        ></close-button>
        <section class="settings">
          <h2>Ontwerp</h2>

          <section class="description">
            <label for="name">Naam</label>
            <input
              id="name"
              type="text"
              v-model="productEdit.name"
              name="name"
              placeholder="Naam van het ontwerp"
              @input="setDirty"
            />
          </section>

          <section class="description">
            <label for="designer">Ontwerp</label>
            <input
              id="designer"
              type="text"
              v-model="productEdit.designer"
              name="designer"
              placeholder="Naam van ontwerper"
              @input="setDirty"
            />
          </section>

          <section class="product-type-holder">
            <span class="title">Product</span>

            <popup-menu class="popup" anchor-position="top">
              <span slot="trigger">
                <span class="product-type">{{ productEdit.productType }}</span
                ><button class="chevron down"></button
              ></span>
              <menu-item
                v-for="productType in printStoreStore.productTypes"
                :key="productType.id"
                @click="setProductType(productType)"
                >{{ productType.name }}
              </menu-item>
            </popup-menu>
          </section>

          <section class="display-spec">
            <select-box
              :selected="displaySpecs.border"
              @action="toggleBorder"
            ></select-box>
            <span class="pointer" @click="toggleBorder">
              Toon een rand om preview
            </span>
          </section>
          <section class="display-spec">
            <select-box
              :selected="availableForAd"
              @action="toggleAd"
            ></select-box>
            <span class="pointer" @click="toggleAd">
              Product opnemen in advertentie
            </span>
          </section>

          <section class="description">
            <label for="product-info">Beschrijving</label>
            <textarea
              id="product-info"
              placeholder="Typ hier een beschrijving van het product"
              v-model="productEdit.description"
              @input="setDirty"
            ></textarea>
          </section>

          <section class="button-holder">
            <button class="pill-button secondary" @click="closeProduct">
              annuleren
            </button>
            <button class="pill-button" @click="save" :disabled="!dirty">
              Toepassen
            </button>
          </section>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import PrintStoreFileUpload from '@/features/printstore/PrintStoreFileUpload.vue'
import {
  getProductPreviewId,
  updateProduct
} from '@/features/printstore/PrintStoreApi'
import cloneDeep from 'lodash-es/cloneDeep'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  props: ['product', 'callback'],
  components: {
    PrintStoreFileUpload
  },
  mounted() {
    this.productEdit = cloneDeep(this.product)
    if (Array.isArray(this.productEdit.displaySpecification)) {
      this.productEdit.displaySpecification = {}
    }
  },
  data() {
    return {
      dirty: false,
      productEdit: {},
      productImage: `/media/print-store/${this.rootStore.user.printStore.id}/preview/${this.product.previewImage}/445`,
      availableForAd: this.product.availableForAd || false
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    displaySpecs() {
      if (this.productEdit.displaySpecification) {
        return this.productEdit.displaySpecification
      } else {
        return {}
      }
    }
  },
  methods: {
    async regeneratePreview() {
      this.productImage = ''
      const image = await getProductPreviewId(this.productEdit.image)
      this.productEdit.previewImage = image.previewId
      this.productImage = `/media/print-store/${this.rootStore.user.printStore.id}/preview/${image.previewId}/445`
      this.setDirty()
    },
    closeProduct() {
      this.$emit('close')
    },
    setProductType(productType) {
      this.productEdit.productType = productType.name
      this.productEdit.productTypeId = productType.id
      this.setDirty()
    },
    setDirty() {
      this.dirty = true
    },
    async save() {
      await updateProduct({
        id: this.productEdit.id,
        name: this.productEdit.name,
        description: this.productEdit.description,
        productTypeId: this.productEdit.productTypeId,
        previewImage: this.productEdit.previewImage,
        designer: this.productEdit.designer,
        availableForAd: this.availableForAd,
        displaySpecification: this.productEdit.displaySpecification || {}
      })
      if (this.callback) {
        this.callback(this.productEdit)
      }
      this.$emit('close')
    },
    onUploadComplete(message) {
      this.productEdit.previewId = message.id
      this.productEdit.previewImage = message.uuid
      this.productImage = `/media/print-store/${this.rootStore.user.printStore.id}/preview/${this.productEdit.previewImage}/445`
      this.setDirty()
    },
    toggleAd() {
      this.availableForAd = !this.availableForAd
      this.setDirty()
    },
    toggleBorder() {
      if (!this.productEdit.displaySpecification) {
        this.productEdit.displaySpecification = {
          border: true
        }
      } else if (!this.productEdit.displaySpecification.border) {
        this.productEdit.displaySpecification.border = true
      } else {
        this.productEdit.displaySpecification.border = false
      }

      this.setDirty()
    }
  }
}
</script>
<style lang="scss" scoped>
@use '../../../sass/base/_colors.scss' as *;

.mobile {
  .left-part {
    margin-right: 0;
    height: auto;
  }
}

.close-button {
  position: absolute;
  right: 15px;
  top: 15px;
}

.left-part {
  padding: 20px;
  height: 540px;
  background-color: white;
  margin-right: 10px;
  border-radius: 5px;
  position: relative;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
.product-detail {
  position: fixed;
  z-index: 11;
  display: flex;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  max-width: 832px;
  min-height: 530px;
  cursor: initial;
}

.mobile {
  .product-detail {
    background-color: white;
    display: block;
    left: 0;
    right: 0;
    height: auto;
    min-height: auto;
    //    border-radius: 25px;
    overflow: auto;
    top: 0;
    bottom: 0;
  }
}

.product-image-container {
  text-align: center;

  main {
    position: relative;

    .image-menu {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
}

.spinner {
  margin-top: 5px;
}

.mobile {
  .image-container {
    margin-bottom: 10px;
    height: auto;
  }

  .product-title {
    font-size: 15px;
  }
}

h2 {
  font-weight: 500;
  color: $text-color;
  margin-bottom: 11px;
  font-size: 13px;
}

.image-container {
  text-align: center;
  margin-bottom: 5px;
  width: 100%;
  height: 417px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
    display: block;
    width: auto;
    height: auto;
  }

  .border {
    border: 1px solid #e3e3e3;
  }
}

.display-spec {
  padding-bottom: 15px;
}

.product-title {
  font-weight: 500;
  color: $text-color;
  font-size: 13px;
  background: #f4f4f4;
  border-radius: 17px;
  padding: 8px 40px;
  display: inline-block;
  margin: 0;
}

.img-button-holder {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.settings {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.description {
  padding-bottom: 15px;

  label {
    width: 63px;
  }

  textarea {
    width: 100%;
    height: 134px;
    margin-top: 3px;
  }

  input {
    width: 154px;
    margin: 0;
  }
}

.product-type-holder {
  padding-bottom: 15px;

  span {
    line-height: normal;
    // margin-right: 5px;
  }

  .title {
    font-weight: 500;
    padding-right: 26px;
  }

  .popup {
    display: inline-block;
  }

  .chevron {
    color: var(--sub-color);
    padding-left: 2px;
    vertical-align: text-bottom;
  }
}

.product-type {
  font-weight: 500;
  color: var(--sub-color);
  margin-right: 5px;
}

.bottom {
  margin-top: auto;
  text-align: right;
}

.right-part {
  padding: 20px;
  background-color: white;
  border-radius: 5px;
  width: 262px;
  flex-shrink: 0;
  //  height: 100%;
}

.mobile {
  .right-part {
    width: auto;
    height: auto;
  }
}
</style>
